import AdHeader from '@/components/adHeader';
import { SeoPages } from '@/components/seoPages';
import Breadcrumbs from '@/components/seoPages/Breadcrumbs';
import { getEntriesCms } from '@/utils/strapi';
import {
    fetchBrandServicePricing,
    fetchPackagePricing,
    getGarageDetailsByCity,
    getGarageDetailsById,
    getReviewsCity,
} from '@/components/fakeDoor/api';
import {
    getGarageId,
    mapCityWithGarage,
} from '@/components/fakeDoor/constants';
import Footer from '@/components/seoPages/Footer';
import { StaticExploreCta } from '@/components/staticExploreCta/StaticExploreCta';
import { useShowCtaAfterFold } from '@/hooks/useShowCtaAfterFold';
import { useDispatch, useSelector } from 'react-redux';
import { setGarageData } from '@/store/modules/garageSlice';
import { useContext, useEffect, useState } from 'react';
import { createGlobalStyle } from 'styled-components';
import { DeviceContext } from '@/pages/_app';
import { useRouter } from 'next/router';
import MetaTags from '@/components/DefaultMetaTags';
import NotFound from '@/pages/404';
import { replaceFieldsWithValues } from '@/components/seoPages/replaceFieldsWithValues';
import BottomNavigation from '@/components/BottomNavigation';
import { viewPageAPI } from '@/analytics/middleware';
import { VIEW_PAGE_FAKEDOOR_LANDING } from '@/analytics/events';
import { loadGrowthbookFeatures, getFeatureValue } from '@/utils/growthbook';
import { HOSTNAME } from '@/lib/constants';
import { HOSTNAME as HOSTNAMEWITHOUTPREFIX } from '@/constants/constantsAckoDrive';
import { AUTH_KEYS, CAR_MAKES, TRACKER_ID } from '@/constants/common';
import {
    fetchAppointmentDetailsFromOrderId,
    fetchRewardDetails,
    getUserPolicy,
    getPincodeByGarageId,
} from '@/utils/api';
import {
    selectCardDetails,
    setAppointments,
} from '@/store/modules/appointmentSlice';
import { generateGarageJsonLd } from '@/config/garageJsonLd.config';
import { GarageCardDetails, IGarageDetails } from '@/types';
import {
    APPOINTMENT_CARD_TYPE,
    PAGE_TYPE,
    SEO_URL_TYPE,
} from '@/constants/enums';
import { getHeaderString } from '@/utils/common';
import { getRewardDetailsFromCoupons } from '@/utils/rewards';
import { ADSC_BOTTOM_NAV } from '@/constants/featureFlags';
import {
    LOCAL_STORAGE_KEYS,
    SESSION_STORAGE_KEYS,
} from '@/constants/storageKeys';
import { RewardConditions, FetchRewardResponseDto } from '@/types';
import RewardGriefity from '@/components/common/rewardGriefity';
import { DEFAULT_REWARD_DESCRIPTION } from '@/constants/index';
import { MODEL_MAPPING } from '@/components/seoPages/Pricing/config';
import {
    clearPincodeAndGarageIdFromLocalStorage,
    getVehicleImageUrl,
} from '@/utils';
import { authenticationService } from '@/services/authentication_service';
import { getGarageCardDetails } from '@/utils/garage';
import { useAppBarUpdate } from '@/hooks/useAppBarUpdate';
import { LIGHT_THEME_APPBAR_CONFIG } from '@/config/appbarConfig';

export const CustomerBodyStyle = createGlobalStyle<{ isMobile?: boolean }>`
    body {
   ${({ isMobile }) =>
       !isMobile &&
       `
            width: 375px;
            height: 667px;
            margin: 0 auto !important;
            overflow: auto;
        `}
    }
`;

function GarageOrBrandSeoPage(props: any) {
    console.log('GarageOrBrandSeoPage props', props);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setGarageData(props.reduxGarageData));
    }, [dispatch, props.reduxGarageData]);

    useAppBarUpdate(LIGHT_THEME_APPBAR_CONFIG);
    const isMobileDevice = useContext(DeviceContext)?.isMobile;
    const router = useRouter();
    const showCta = useShowCtaAfterFold('CarServices');
    const routerQuery = router.query;
    const city = getHeaderString(routerQuery['city']);
    const garageOrBrand = getHeaderString(routerQuery['garageOrBrand']);
    const cardData = useSelector(selectCardDetails) || {};
    const garageData: IGarageDetails = props?.reduxGarageData;
    const jsonLd = generateGarageJsonLd(
        [garageData],
        SEO_URL_TYPE.GARAGE_OR_BRAND,
        city,
        garageOrBrand
    );
    const { utm_medium } = router.query;
    // const [showRewardGriefity, setShowRewardGriefity] = useState(false);

    // useEffect(() => {
    //     const showReward = sessionStorage.getItem(
    //         SESSION_STORAGE_KEYS.BANNER_SHOWN
    //     );
    //     if (showReward) {
    //         setShowRewardGriefity(true);
    //         sessionStorage.removeItem(SESSION_STORAGE_KEYS.BANNER_SHOWN);
    //     }
    // }, []);

    useEffect(() => {
        clearPincodeAndGarageIdFromLocalStorage();
        if (
            props?.garageId &&
            !props?.isMultipleGarage &&
            !props?.appointmentData?.appointment_id
        ) {
            localStorage.setItem(LOCAL_STORAGE_KEYS.GARAGE_ID, props.garageId);
        }
        if (utm_medium) {
            sessionStorage.setItem(
                SESSION_STORAGE_KEYS.UTM_MEDIUM,
                utm_medium as string
            );
        }
    }, [
        props?.garageId,
        props.isMultipleGarage,
        props.appointmentData?.appointment_id,
    ]);

    const { isCouponAvailable, couponCode, offerDetails } =
        getRewardDetailsFromCoupons(props?.rewardDetails?.coupons);

    useEffect(() => {
        const viewPageLoadEvent = async () => {
            const isGarage = props?.isGarage;
            const isBrand = props?.isBrand;

            let pageType = '';

            if (isGarage && !isBrand) {
                pageType = 'hyperlocal';
            } else if (isGarage && isBrand) {
                pageType = 'hyperlocal_brand';
            } else if (!isGarage && isBrand) {
                pageType = 'city_brand';
            }
            await viewPageAPI({
                event_name: VIEW_PAGE_FAKEDOOR_LANDING,
                customAttributes: {
                    page_type: pageType,
                    show_bottom_nav: props.showBottomNav,
                    is_coupon_available: isCouponAvailable,
                    coupon_code: couponCode,
                    offer_details: offerDetails,
                },
                isFakeDoor: true,
            });
        };
        viewPageLoadEvent();

        if (props?.appointmentData?.garage_id) {
            dispatch(setAppointments(props?.appointmentData));
        }
    }, []);

    if (props?.isInvalid) {
        return (
            <>
                <CustomerBodyStyle isMobile={isMobileDevice} />
                <NotFound />
            </>
        );
    }

    return (
        <>
            <MetaTags
                pathname={`${city}/${garageOrBrand}`}
                title={replaceFieldsWithValues(
                    props?.isBrand
                        ? props?.garageSeoCommonsdata?.brandMetaTitle
                        : props?.garageSeoCommonsdata?.locationMetaTitle,
                    {
                        location: props?.garage
                            ? `${props?.garage}, ${props?.city}`
                            : `${props?.city}`,
                        brand: props?.brand,
                    }
                )}
                description={replaceFieldsWithValues(
                    props?.isBrand
                        ? props?.garageSeoCommonsdata?.brandMetaDescription
                        : props?.garageSeoCommonsdata?.locationMetaDescription,
                    {
                        location: props?.garage
                            ? `${props?.garage}, ${props?.city}`
                            : `${props?.city}`,
                        brand: props?.brand,
                    }
                )}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'Corporation',
                        name: 'ACKO Drive',
                        url: 'https://ackodrive.com/',
                        logo: 'https://ackodrive-assets.s3.amazonaws.com/media/Ackodrive_2023_Color.png',
                        contactPoint: {
                            '@type': 'ContactPoint',
                            telephone: '18002662250',
                            contactType: 'customer service',
                            areaServed: 'IN',
                            availableLanguage: ['en', 'Hindi'],
                        },
                        sameAs: [
                            'https://www.facebook.com/ackodrive/',
                            'https://www.instagram.com/ackodrive/',
                            'https://twitter.com/ackodrive',
                        ],
                    }),
                }}
            />
            {jsonLd && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(jsonLd),
                    }}
                />
            )}
            <CustomerBodyStyle isMobile={isMobileDevice} />
            <AdHeader
                hideHamburgerMenu={false}
                isMobileDevice={true}
                hideShadow={true}
            />
            {props?.garageSeoCommonsdata?.ReusableComponents?.map(
                (ReusableComponent: any, index: number) => {
                    return (
                        <section
                            id={ReusableComponent.componentName}
                            key={ReusableComponent.componentName}
                        >
                            <SeoPages
                                ReusableComponent={ReusableComponent}
                                cardData={cardData}
                                {...props}
                            />
                        </section>
                    );
                }
            )}
            <Breadcrumbs
                list={[
                    { displayName: 'Home', link: `${HOSTNAMEWITHOUTPREFIX}/` },
                    {
                        displayName: 'Service Centre',
                        link: `${HOSTNAME}`,
                    },
                    {
                        displayName: `${props.city}`,
                        link: `${HOSTNAME}/${city}`,
                    },
                    {
                        displayName: `${props.isGarage && props.isBrand ? `${props.brand} service in ${props.garage}` : props.garage ? props.garage : `${props.brand} service`}`,
                        link: `${HOSTNAME}/${city}/${garageOrBrand}`,
                    },
                ]}
            />
            {props.showBottomNav ? (
                <BottomNavigation />
            ) : (
                showCta && (
                    <StaticExploreCta
                        targetId="CarServices"
                        withHeader={true}
                        hasCardData={
                            !!cardData && !!Object.keys(cardData).length
                        }
                    />
                )
            )}
            {/* {showRewardGriefity && (
                <RewardGriefity
                    title={''}
                    description={DEFAULT_REWARD_DESCRIPTION}
                    couponCode={''}
                    setShowReward={setShowRewardGriefity}
                    showReward={showRewardGriefity}
                    showCouponCode={false}
                />
            )} */}
            <Footer
                cities={props?.garageSeoCommonsdata?.liveCities}
                garage={props?.garage}
            />
        </>
    );
}

export const getServerSideProps = async (ctx: any) => {
    const { params, req } = ctx;
    const query = ctx.query;
    const isBtlCampaign = query?.utm_medium === 'btl_campaign';
    console.log('isBtlCampaign :: ', isBtlCampaign);
    const slug = params?.garageOrBrand as string;
    let city = params?.city as string;
    if (city.includes('-')) {
        let tempCity = city.split('-') || [];
        let cityName = '';
        tempCity?.map((temp: any) => {
            cityName =
                cityName +
                temp.charAt(0).toUpperCase() +
                temp.slice(1).toLowerCase() +
                ' ';
        });
        city = cityName.trim();
    } else {
        city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
    }
    const userId =
        getHeaderString(req.headers[AUTH_KEYS.X_USER_ID]) ||
        getHeaderString(req.headers[TRACKER_ID]);
    await loadGrowthbookFeatures(userId);
    const showBottomNav = getFeatureValue({ flagName: ADSC_BOTTOM_NAV });

    let isBrand = false;
    let isGarage = true;
    let brand = '';
    let garage = '';
    let urlGarage = '';

    function formatServiceString(input: string): string[] {
        const parts = input.split('-in-');
        if (parts?.[1]) {
            urlGarage = parts[1];
            if (urlGarage.startsWith('-')) {
                urlGarage = urlGarage.slice(1);
            }
        } else {
            urlGarage = parts[0];
        }

        const formatString = (str: string): string => {
            return str
                .replace(/-/g, ' ')
                .split(' ')
                .map(
                    (word) =>
                        word.charAt(0).toUpperCase() +
                        word.slice(1).toLowerCase()
                )
                .filter(
                    (word) =>
                        word.toLowerCase() !== 'service' &&
                        word.toLowerCase() !== 'car'
                )
                .join(' ')
                .trim();
        };

        return parts.map(formatString);
    }

    const slugParts = formatServiceString(slug);

    let garageSeoCommonsdata: any = await getEntriesCms(
        `garage-seo-commons`,
        'live',
        'createdAt',
        999,
        '',
        '',
        '',
        true
    );

    let tempLiveCities = garageSeoCommonsdata?.[0]?.attributes?.liveCities;

    if (!tempLiveCities[params?.city?.toLowerCase()]) {
        return {
            props: {
                garageSeoCommonsdata: [],
                isCity: true,
                city,
                garageSeoManualdata: {},
                garageList: {},
                garageData: [],
                isInvalid: true,
            },
        };
    }

    let route = `service-centre/${params?.city}/${params?.garageOrBrand}`;

    let garageSeoBrands: any = await getEntriesCms(
        `garage-brand-services`,
        'live',
        'createdAt',
        999,
        '',
        '',
        '',
        true
    );

    if (
        garageSeoBrands?.[0]?.attributes?.brands?.[
            slugParts[0]?.toLocaleLowerCase()
        ] ||
        slugParts.length > 1
    ) {
        isBrand = true;
        brand = slugParts[0];
        if (slugParts.length === 1) {
            isGarage = false;
        } else {
            garage = slugParts[1]
                .split(' ')
                .map((word, index) => {
                    return index === 0 && word.length <= 4
                        ? word.toUpperCase()
                        : word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase();
                })
                .join(' ');
        }
    } else {
        garage = slugParts[0]
            .split(' ')
            .map((word, index) => {
                return index === 0 && word.length <= 4
                    ? word.toUpperCase()
                    : word.charAt(0).toUpperCase() +
                          word.slice(1).toLowerCase();
            })
            .join(' ');
    }
    if (
        (isGarage &&
            !tempLiveCities[params?.city?.toLowerCase()].localities[
                urlGarage?.toLocaleLowerCase()
            ]) ||
        (isBrand &&
            !garageSeoBrands?.[0]?.attributes?.brands?.[
                slugParts[0]?.toLocaleLowerCase()
            ])
    ) {
        return {
            props: {
                garageSeoCommonsdata: [],
                isCity: true,
                city,
                garageSeoManualdata: {},
                garageList: {},
                garageData: [],
                isInvalid: true,
            },
        };
    }

    let garageSeoManualdata: any = {};
    if (route) {
        garageSeoManualdata = await getEntriesCms(
            `garage-seo-manual-contents`,
            'live',
            'createdAt',
            999,
            'url',
            '$eq',
            route,
            true
        );
    }

    let n = [];
    let u = [...garageSeoCommonsdata?.[0]?.attributes.ReusableComponents];
    n = u.find((x) => x.componentName === 'Faq');
    let tempshowQuestions = Number(n?.showQuestions);
    if (garageSeoManualdata?.[0]?.attributes?.Faqs) {
        let tempData = garageSeoManualdata?.[0]?.attributes?.Faqs;
        n = tempData;
        let len = Math.ceil(tempData?.Faqs?.length / tempshowQuestions);
        let rdm = Math.floor(Math.random() * len);
        tempData = {
            ...tempData,
            Faqs: tempData.Faqs.splice(
                rdm * tempshowQuestions,
                tempshowQuestions
            ),
        };
        if (garageSeoManualdata?.[0]?.attributes) {
            garageSeoManualdata[0].attributes.Faqs = tempData;
        }
    }

    let garageData: any = [];
    let reduxGarageData = {};
    let garageId;
    let mappedLocalities =
        tempLiveCities[params?.city?.toLowerCase()].localities;
    if (isGarage) {
        if (mappedLocalities?.[urlGarage?.toLocaleLowerCase()]) {
            urlGarage = mappedLocalities?.[urlGarage?.toLocaleLowerCase()];
        }

        const currentGarageId = await getGarageId(urlGarage);
        garageData = await getEntriesCms(
            `acko-garages`,
            'live',
            'createdAt',
            999,
            `garageId`,
            '$eq',
            `${currentGarageId}`,
            false,
            ['garageId'],
            [
                'servicing_brands',
                'servicing_brands.company_image_url',
                'garage_review_ratings',
                'garage_review_ratings.reviews',
            ]
        );

        const res = await getGarageDetailsById(currentGarageId);
        reduxGarageData = res;
        garageId = currentGarageId;
    } else {
        const urlGarage = await mapCityWithGarage[params?.city?.toLowerCase()];
        const currentGarageId = await getGarageId(urlGarage);
        garageData = await getEntriesCms(
            `acko-garages`,
            'live',
            'createdAt',
            999,
            `garageId`,
            '$eq',
            `${currentGarageId}`,
            false,
            ['garageId'],
            [
                'servicing_brands',
                'servicing_brands.company_image_url',
                'garage_review_ratings',
                'garage_review_ratings.reviews',
            ]
        );
        const res = await getGarageDetailsById(currentGarageId);
        reduxGarageData = res;
        garageId = currentGarageId;
    }

    let garageList = await getGarageDetailsByCity(
        params?.city?.toLowerCase() === 'bangalore'
            ? 'bengaluru'
            : params?.city?.toLowerCase() === 'new-delhi'
              ? 'new delhi'
              : params?.city,
        true
    );

    let reviewData: any = await getReviewsCity(garageId);

    const filteredGarageList = isGarage
        ? garageList.filter(
              (item: any) =>
                  item.garageLandingPath &&
                  !item.garageLandingPath
                      .replace(/-/g, ' ')
                      .toLowerCase()
                      .includes(garage.toLowerCase())
          )
        : garageList;
    const appointmentData = await fetchAppointmentDetailsFromOrderId(
        ctx.req,
        query?.appointmentId
    );
    const userPolicyType = await getUserPolicy(ctx.req);
    let rewardDetails: FetchRewardResponseDto | undefined;

    const data: RewardConditions = {
        garage_id: garageId,
    };
    rewardDetails = await fetchRewardDetails(ctx.req, data);

    const slugify = (str: string) => str.toLowerCase().replace(/ /g, '-');

    let makeName = MODEL_MAPPING[CAR_MAKES.MARUTI].makeName;
    let modelName = MODEL_MAPPING[CAR_MAKES.MARUTI].modelName;
    let modelId = MODEL_MAPPING[CAR_MAKES.MARUTI].modelId;
    let fuelType = MODEL_MAPPING[CAR_MAKES.MARUTI].fuelType;

    const make = slug.split('-')[0];
    const modelInfo = MODEL_MAPPING[make];

    if (modelInfo) {
        makeName = modelInfo.makeName;
        modelName = modelInfo.modelName;
        modelId = modelInfo.modelId;
        fuelType = modelInfo.fuelType;
    }

    const [servicePricingData, packagePricingData] = await Promise.all([
        fetchBrandServicePricing(modelId, fuelType, garageId).catch((error) => {
            console.error('Error fetching service pricing data: ', error);
            return null;
        }),
        fetchPackagePricing(modelId, fuelType, garageId).catch((error) => {
            console.error('Error fetching package pricing data: ', error);
            return null;
        }),
    ]);
    const carImageURL: string = getVehicleImageUrl(
        slugify(makeName),
        slugify(modelName)
    );

    const isLoggedInServerSide = authenticationService.isLoggedInServerBrowser(
        ctx.req,
        ctx.res
    );

    let garageCardDetails: GarageCardDetails[] = [];

    const pincodeResponse = await getPincodeByGarageId(garageId, ctx.req);
    const pincode = pincodeResponse?.pincode;
    if (pincode) {
        garageCardDetails = await getGarageCardDetails(
            garageId,
            pincode,
            ctx.req as any
        );
    }

    const isMultipleGarage = garageCardDetails.length > 1;

    return {
        props: {
            garageSeoCommonsdata: garageSeoCommonsdata?.[0]?.attributes || [],
            slugParts: slugParts,
            isGarage,
            isBrand,
            city,
            garage,
            brand,
            garageSeoManualdata: garageSeoManualdata?.[0]?.attributes || {},
            garageList: filteredGarageList || {},
            garageData: garageData?.[0]?.attributes || [],
            reduxGarageData: reduxGarageData || {},
            garageId: garageId || '',
            reviewData: reviewData || {},
            showBottomNav: showBottomNav,
            params,
            appointmentData: appointmentData || {},
            rewardDetails: rewardDetails || {},
            servicePricingData: servicePricingData?.service_pricing || [],
            packagePricingData: packagePricingData?.package_pricing || [],
            carImageURL: carImageURL || '',
            seoMakeName: makeName,
            seoModelName: modelName,
            isLoggedInServerSide: isLoggedInServerSide,
            userPolicyType: userPolicyType || {},
            garageVideoUrl: (reduxGarageData as any)?.garage_video_url || null,
            garageCardDetails: garageCardDetails || [],
            isMultipleGarage: isMultipleGarage,
            pincode: pincode,
            pageType: PAGE_TYPE.GARAGE_PAGE,
        },
    };
};

export default GarageOrBrandSeoPage;
